import React from "react";
import type { WitnessStatement } from "../../../../components/RCA/types";

interface RCAWitnessSectionProps {
  witnesses: WitnessStatement[];
  onAdd: () => void;
  onUpdate: (index: number, field: keyof WitnessStatement, value: string) => void;
  onRemove: (index: number) => void;
  readOnly: boolean;
}

const RCAWitnessSection: React.FC<RCAWitnessSectionProps> = ({
  witnesses,
  onAdd,
  onUpdate,
  onRemove,
  readOnly,
}) => {
  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-semibold">E. Key Witness Statement</h3>
        {!readOnly && (
          <button
            type="button"
            onClick={onAdd}
            className="px-4 py-2 bg-[#0fa9a6] text-white rounded hover:bg-[#0d8f8c]"
          >
            Add Witness
          </button>
        )}
      </div>
      {witnesses.length === 0 ? (
        <p className="text-gray-500 text-center py-4">
          No witness statements added
        </p>
      ) : (
        <div className="space-y-4">
          {witnesses.map((witness, index) => (
            <div key={index} className="border p-4 rounded">
              <div className="grid grid-cols-2 gap-4 mb-2">
                <div>
                  <label className="block text-sm font-medium mb-1">
                    Witness Name
                  </label>
                  <input
                    type="text"
                    value={witness.witnessName}
                    onChange={(e) =>
                      onUpdate(index, "witnessName", e.target.value)
                    }
                    className="w-full p-2 border rounded"
                    readOnly={readOnly}
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium mb-1">
                    Contact Info
                  </label>
                  <input
                    type="text"
                    value={witness.contactInfo}
                    onChange={(e) =>
                      onUpdate(index, "contactInfo", e.target.value)
                    }
                    className="w-full p-2 border rounded"
                    readOnly={readOnly}
                  />
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">
                  Statement
                </label>
                <textarea
                  value={witness.statement}
                  onChange={(e) =>
                    onUpdate(index, "statement", e.target.value)
                  }
                  className="w-full p-2 border rounded"
                  rows={3}
                  readOnly={readOnly}
                  placeholder="Describing the event what the witness first saw"
                />
              </div>
              {!readOnly && (
                <button
                  type="button"
                  onClick={() => onRemove(index)}
                  className="mt-2 text-red-600 hover:text-red-800 text-sm"
                >
                  Remove Witness
                </button>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default RCAWitnessSection;
